<template>
  <div class="overlap-container" v-show="showOverlap">
    <div class="overlap-wrapper" :class="{
      'overlap-fade-out': overlapFadeOut,
      'overlap-fade-in': overlapFadeIn
    }">
      <div class="overlap-outside">
        <div class="credit_card" :class="{ 'fill_cvv': activeFillCvv }">
          <div class="credit_card__front credit_card__part">
            <p class="credit_card_number">{{ numero || '____ ____ ____ ____' }}</p>
            <div class="credit_card__space-75">
              <span class="credit_card__label">NOME</span>
              <p class="credit_card__info">{{ nome || '___' }}</p>
            </div>
            <div class="credit_card__space-25">
              <span class="credit_card__label">VALIDADE</span>
              <p class="credit_card__info">{{ validade || '__/__' }}</p>
            </div>
          </div>
          <div class="credit_card__back credit_card__part">
            <div class="credit_card__black-line"></div>
            <div class="credit_card__back-content">
              <div class="credit_card__secret">
                <p class="credit_card__secret--last">{{ cvv || '___' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'CheckoutCreditCard',
  data () {
    return {
      showOverlap: false,
      showCheckoutCreditCardYupin: false,
      numero: '',
      nome: '',
      validade: '',
      cvv: '',
      activeFillCvv: false,
    }
  },
  computed: {
    overlapFadeIn () {
      return this.showCheckoutCreditCardYupin;
    },
    overlapFadeOut () {
      return this.showCheckoutCreditCardYupin === false;
    },
  },
  mounted () {
    window.EventBus.$on('YUPIN_SHOW_CHECKOUT_CREDIT_CARD', () => {
      this.showOverlap = true;
      window.EventBus.$emit('OVERLAP_SHOWED');

      setTimeout(() => {
        this.showCheckoutCreditCardYupin = true;
      }, 250);
    });

    window.EventBus.$on('YUPIN_CLOSE_CHECKOUT_CREDIT_CARD', () => {
      this.showCheckoutCreditCardYupin = false;

      setTimeout(() => {
        this.showOverlap = false;
      }, 250);
    });

    window.EventBus.$on('ON_FOCUS', (fluxoToken, name) => {
      if (['9d678d80-093f-41f5-b5ad-f61831bced10', 'c74f3159-7572-437e-85fc-bfb51faaf6c2', 'a3d29a28-6424-4dfb-ade8-2c51adcadfb7'].includes(fluxoToken) && name === 'cvv_cartao') {
        this.activeFillCvv = true;
      }
    });

    window.EventBus.$on('ON_TYPE', (fluxoToken, name, value) => {
      if (['9d678d80-093f-41f5-b5ad-f61831bced10', 'c74f3159-7572-437e-85fc-bfb51faaf6c2', 'a3d29a28-6424-4dfb-ade8-2c51adcadfb7'].includes(fluxoToken)) {
        if (name === 'numero_cartao') {
          this.numero = value;
        } else if (name === 'nome_cartao') {
          this.nome = value;
        } else if (name === 'validade_cartao') {
          this.validade = value;
        } else if (name === 'cvv_cartao') {
          this.cvv = value;
        }
      }
    });
  }
}
</script>

<style lang="scss" scoped>
  .overlap-container {
    height: 80%;
    z-index: 1;
    box-shadow: 0 1px 20px rgba(0, 0, 0, 0.2);
  }

  .overlap-wrapper {
    position: relative;
    height: 100%;

    &.overlap-fade-out {
      visibility: hidden;
      opacity: 0;
      transition: visibility 0s linear 250ms, opacity 250ms;
    }
    &.overlap-fade-in {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s linear 0s, opacity 250ms;
    }
  }

  .overlap-outside {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    box-sizing: border-box;

    &.align-items-start {
      align-items: start;
    }
  }

  .credit_card {
    width: 253px;
    height: 150px;
    -webkit-perspective: 600px;
    -moz-perspective: 600px;
    perspective: 600px;
  }

  .credit_card__part{
    box-shadow: 1px 1px #aaa3a3;
    top: 0;
    position: absolute;
    z-index: 1000;
    left: 0;
    display: inline-block;
    width: 253px;
    height: 150px;
    box-sizing: border-box;
    background: #8228d1;
    border-radius: 8px;
    -webkit-transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    -moz-transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    -ms-transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    -o-transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    -webkit-transform-style: preserve-3d;
    -moz-transform-style: preserve-3d;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
  }

  .credit_card__front{
    padding: 18px;
    -webkit-transform: rotateY(0);
    -moz-transform: rotateY(0);
  }

  .credit_card__back {
    padding: 18px 0;
    -webkit-transform: rotateY(-180deg);
    -moz-transform: rotateY(-180deg);
  }

  .credit_card__black-line {
    margin-top: 5px;
    height: 38px;
    background-color: #303030;
  }

  .credit_card__logo {
    height: 16px;
  }

  .credit_card__front-logo{
    position: absolute;
    top: 18px;
    right: 18px;
  }
  .credit_card__square {
    border-radius: 5px;
    height: 30px;
  }

  .credit_card_number {
    display: block;
    width: 100%;
    word-spacing: 4px;
    font-size: 16px;
    letter-spacing: 2px;
    color: #fff;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .credit_card__space-75 {
    width: 75%;
    float: left;
  }

  .credit_card__space-25 {
    width: 25%;
    float: left;
  }

  .credit_card__label {
    font-size: 10px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.8);
    letter-spacing: 1px;
  }

  .credit_card__info {
    margin-bottom: 0;
    margin-top: 5px;
    font-size: 11px;
    line-height: 18px;
    color: #fff;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .credit_card__back-content {
    padding: 15px 15px 0;
  }
  .credit_card__secret--last {
    color: #303030;
    text-align: right;
    margin: 0;
    font-size: 14px;
  }

  .credit_card__secret {
    padding: 5px 12px;
    background-color: #fff;
    position:relative;
  }

  .credit_card__secret:before{
    content:'';
    position: absolute;
    top: -3px;
    left: -3px;
    height: calc(100% + 6px);
    width: calc(100% - 42px);
    border-radius: 4px;
    background: repeating-linear-gradient(45deg, #ededed, #ededed 5px, #f9f9f9 5px, #f9f9f9 10px);
  }

  .credit_card__back-logo {
    position: absolute;
    bottom: 15px;
    right: 15px;
  }

  .credit_card__back-square {
    position: absolute;
    bottom: 15px;
    left: 15px;
  }

  .credit_card:hover .credit_card__front,
  .credit_card.fill_cvv .credit_card__front {
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
  }

  .credit_card:hover .credit_card__back,
  .credit_card.fill_cvv .credit_card__back {
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
  }

  .card-titular-cartao-credito {
    background: #edf1f4;
  }
</style>
